import ThePortrait from './thePortrait/ThePortrait'
import TheOpenPortrait from './thePortrait/TheOpenPortrait'
import TheBook from './TheBook'
import TheSign from './TheSign'
import TheChair from './TheChair'
import TheGlobe from './TheGlobe'
import TheFloorTile from './TheFloorTile'
import TheAnswerForm from './theAnswerForm/TheAnswerForm'
import TheLibrarian from './TheLibrarian'

import bookProcess from '../../../../images/clues/library/bookProcess.png'


const libraryData = [
    {
        name: 'The Portrait',
        id: 'portrait',
        sceneText: "A beautiful painting",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <ThePortrait />,
        cluesAvailable: true,
        clues: [
            {
                text: 'Page 4 will help you with the portrait.'
            },
            {
                text: 'On page 4 there are 3 words: RATS, GOD, SNOOPS. These three words tell you which buttons to press.'
            },
            {
                text: 'Try reading RATS, GOD, SNOOPS backwards. The next hint will be the solution.'
                
            },
            {
                text: 'Reading the words of page 14 backwards you get: SPOONS DOG STAR. Press those buttons in that order.'
            }
        ]
    },
    {
        name: 'The Open Portrait',
        id: 'openPortrait',
        sceneText: "This portrait was hiding something",
        puzzleVisible: false,
        puzzleLocked: false,
        component: <TheOpenPortrait />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Can those symbols help you identify the 3 digit category number?'
            },
            {
                text: 'Those symbols appear somewhere else. Each one equals a digit in the category number.'
            },
            {
                text: "The page numbers in the Professor's journal each have a symbol with them. The next hint will be the solution."
            },
            {
                text: 'This category number is: 364'
            }
        ]
    },
    {
        name: 'The Book',
        id: 'book',
        sceneText: "An ancient text. I wonder what it says",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheBook />,
        cluesAvailable: true,
        clues: [
            {
                text: 'Use page 5 to translate the symbol on the book into a 4 digit sub-category code?'
            },
            {
                text: 'Use page 5 to work out which 4 symbols have been combined on the book cover. Some of those symbols may not have been translated by the Professor, but you can use his work to figure them out.'
            },
            {
                text: 'Numbers 1 to 9 each have a symbol. Rotating that symbol gives the tens, hundreds and thousands version of that number. Combining one symbol from each row will give you a 4 digit number like in the examples.'
            },
            {
                text: 'These are the four symbols which are combined on the book. Use page 5 to work out what the 4 digit number is? The next hint will be the solution.',
                image: bookProcess
            },
            {
                text: 'The sub category code is: 1523'
            }
        ]
    },
    {
        name: 'The Sign',
        id: 'sign',
        sceneText: "If you're looking for a sign, this is it.",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheSign />,
        cluesAvailable: true,
        clues: [
            {
                text: 'Can you use the sign to figure out the book title?'
            },
            {
                text: 'The professor has a word grid on page 4 which matches the grid on the sign. Find the fastest route out of the maze on screen.'
            },
            {
                text: 'Using page 4 you can asign a letter to each square in the maze. Use each letter from the squares you pass through when following the fastest route out of the maze. The next hint will be the solution.'
            },
            {
                text: 'The book title is: CATCHING A CRIMINAL'
            }
        ]
    },
    {
        name: 'The Messages',
        id: 'chair',
        sceneText: "A seat in front of the fire. Toasty",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheChair />,
        cluesAvailable: true,
        clues: [
            {
                text: 'The Professor has left you messages on the chair, the floor tile and the globe. Can you use them with page 18?'
            },
            {
                text: 'Each message gives you a shape. The globe = circle, the floor tile = diamond, the chair = pentagon. For each message, draw a line on the dotted grid, starting at the relevant shape.'
            },
            {
                text: "Following the messages you will create an outline on the dotted grid. Use scissors to cut along the line you have drawn. Can you find where this shape goes in the Professor's journal?"
            },
            {
                text: 'Place your newly cut out shape over the text on page 7. Make sure CHAPTER 1 lines up. If your overlay has been cut & positioned correctly you will now know the author of the book. The next hint will be the solution.'
            },
            {
                text: 'The author is: PHILOMENA CERTAIN'
            }
        ]
    },
    {
        name: 'The Globe',
        id: 'globe',
        sceneText: "Set a course for justice",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheGlobe />,
        cluesAvailable: false,
    },
    {
        name: 'The Floor Tile',
        id: 'floorTile',
        sceneText: "The floor is badly scratched",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheFloorTile />,
        cluesAvailable: false,
    },
    {
        name: 'The Answer Form',
        id: 'answerForm',
        sceneText: "Books. Books everywhere. But which one do I need?",
        puzzleVisible: true,
        puzzleLocked: false,
        component: <TheAnswerForm />,
        cluesAvailable: false,
    },
    {
        name: 'The Librarian',
        id: 'librarian',
        sceneText: "The librarian gives you an icy stare. No book form? No talking.",
        specialIcon: 'fas fa-user-lock',
        puzzleVisible: true,
        puzzleLocked: true,
        component: <TheLibrarian finalPuzzle />,
        cluesAvailable: false,
        clues: [
            {
                text: 'Click on the book form in your inventory and select the librarian icon.'
            }
        ]
    }
]

export default libraryData